
import React from 'react';
import { Sparkles } from 'lucide-react';
import { useBreakpoint } from '@/hooks/use-mobile';
import { cn } from '@/lib/utils';

interface HeaderSectionProps {
  title: string;
  description: string;
  badge: string;
  className?: string;
}

const HeaderSection: React.FC<HeaderSectionProps> = ({
  title,
  description,
  badge,
  className
}) => {
  const { isMobile } = useBreakpoint();
  
  return (
    <div className={cn("max-w-3xl mx-auto animate-fade-in relative z-10 pt-6 md:pt-0", className)}>
      <div className="flex justify-center mb-3 md:mb-5">
        <div className={`inline-flex items-center gap-1.5 md:gap-2 rounded-full bg-gradient-to-r from-[#FEE6D8] to-[#FEE6D8]/80 text-[#003a70] font-medium shadow-sm hover:shadow-md transition-all duration-300 transform hover:scale-105 ${isMobile ? 'px-3 py-1.5 text-xs' : 'px-6 py-2.5 text-base'}`}>
          <Sparkles size={isMobile ? 14 : 20} className="text-[#003a70] animate-pulse" />
          <span>{badge}</span>
        </div>
      </div>
      <h2 className="text-center font-bold text-brand-dark mb-4 md:mb-6 px-2 md:px-0">
        <span className={`font-normal ${isMobile ? 'text-2xl md:text-4xl' : 'text-4xl'}`}>
          {title}
        </span>
      </h2>
      <p className="text-center text-brand-gray text-sm md:text-lg max-w-full md:max-w-2xl lg:max-w-4xl mx-auto leading-relaxed px-2 md:px-2">
        {isMobile ? description.split('.')[0] + '.' : description}
      </p>
    </div>
  );
};

export default HeaderSection;
